import { Roll } from "@/shared/models/Roll";
import { HelmetDexteel } from "@dexteel/mesf-core";
import Grid2 from "@mui/material/Grid2";
import { masterDetailsMinHeight, pageBgColor } from "@/utils/theme";
import { useQuery } from "@tanstack/react-query";
import { getBrokenRolls } from "../../repositories/BrokenRollsRepository";
import { TableBrokenRolls } from "./components/TableBrokenRolls";

export const useBrokenRolls = () => {
	return useQuery<Roll[], Error>({
		queryKey: ["brokenRolls"],
		queryFn: ({ signal }) => getBrokenRolls(signal),
		refetchInterval: 60_000,
	});
};

export const BrokenRollsPage = () => {
	return (
		<>
			<HelmetDexteel title="Broken Rolls" />
			<Grid2
				size={{ md: 12, xs: 12 }}
				sx={{ backgroundColor: pageBgColor, minHeight: masterDetailsMinHeight }}
			>
				<TableBrokenRolls />
			</Grid2>
		</>
	);
};
